<template>
  <!--<img class="img-btn fadeInDown animated" src="../assets/images/login_deng.png">-->
  <div
    class="deng fadeInDown animated"
    :style="
      'background:url(' +
      dengBgImg[dengIndex] +
      ') center top / cover no-repeat'
    "
  >
    <img class="img-btn fadeInDown animated" :src="dengImg[charIndex]" />
    <img class="deng-char" src="../assets/images/deng/char.png" />
  </div>
</template>

<script>
export default {
  name: "deng",
  data() {
    return {
      timer: null,
      charTimer: null,
      dengIndex: 0,
      charIndex: 0,
      dengImg: [
        require("../assets/images/deng/3.png"),
        require("../assets/images/deng/4.png"),
        require("../assets/images/deng/2.png"),
      ],
      dengBgImg: [
        require("../assets/images/deng/border_one.png"),
        require("../assets/images/deng/border_two.png"),
      ],
    };
  },
  created() {
    //霓虹灯
    this.timer = setInterval(() => {
      this.dengIndex++;
      if (this.dengIndex >= 2) {
        this.dengIndex = 0;
      }
    }, 1000);

    // this.charTimer = setInterval(() => {
    //     this.charIndex++;
    //     if (this.charIndex >= 3) {
    //         this.charIndex = 0;
    //     }
    // }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.charTimer);
    this.timer = null;
    this.charTimer = null;
  },
};
</script>

<style lang="scss" scoped>
.deng {
  .deng-char {
    position: absolute;
    top: 2%;
    width: 100%;
    left: 0;
  }
}
</style>
